import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const anchorLinkProps = buildProps({
  title: String,
  href: String
});

export { anchorLinkProps };
//# sourceMappingURL=anchor-link.mjs.map
